import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

const initialState = {
  items: [],
  loading: false,
  error: null,
};

export const fetchConstituencies = createAsyncThunk('constituencies/fetchAll', async () => {
  const response = await api.get('/constituencies');
  if (response.data && Array.isArray(response.data.data)) {
    return response.data.data;
  }
  if (Array.isArray(response.data)) {
    return response.data;
  }
  throw new Error('Unexpected data format');
});

export const createConstituency = createAsyncThunk('constituencies/create', async (data) => {
  const response = await api.post('/constituencies', data);
  return response.data.data;
});

export const updateConstituency = createAsyncThunk('constituencies/update', async ({ id, ...data }) => {
  const response = await api.put(`/constituencies/${id}`, data);
  return response.data.data;
});

export const deleteConstituency = createAsyncThunk('constituencies/delete', async (id) => {
  await api.delete(`/constituencies/${id}`);
  return id;
});

const constituenciesSlice = createSlice({
  name: 'constituencies',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConstituencies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchConstituencies.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchConstituencies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch constituencies';
      })
      .addCase(createConstituency.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createConstituency.fulfilled, (state, action) => {
        state.loading = false;
        state.items.push(action.payload);
      })
      .addCase(createConstituency.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to create constituency';
      })
      .addCase(updateConstituency.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateConstituency.fulfilled, (state, action) => {
        state.loading = false;
        const idx = state.items.findIndex((item) => item.id === action.payload.id);
        if (idx !== -1) state.items[idx] = action.payload;
      })
      .addCase(updateConstituency.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to update constituency';
      })
      .addCase(deleteConstituency.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteConstituency.fulfilled, (state, action) => {
        state.loading = false;
        state.items = state.items.filter((item) => item.id !== action.payload);
      })
      .addCase(deleteConstituency.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to delete constituency';
      });
  },
});

export default constituenciesSlice.reducer; 